import {Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil, tap, throttleTime} from 'rxjs/operators';

@Directive({
  selector: '[gtDebounceClick]'
})
export class GtDebounceClickDirective implements OnInit, OnDestroy {
  @Input() debounceTimeInMs = 700;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private destroyed$ = new Subject<void>();

  ngOnInit() {
    this.clicks
      .pipe(
        throttleTime(this.debounceTimeInMs),
        tap(e => this.debounceClick.emit(e)),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
